import React from "react";
import CriterionSelectAll from "../common/CriterionSelectAll";
import useSelectAll from "../useSelectAll";
import SimpleCheckbox from "./SimpleCheckbox";
import { checkboxesChoicesType, checkboxesType } from "../../../../common/types/search/search";

export interface CheckboxesProps {
	label: string;
	choices: checkboxesChoicesType;
	criterionKey: string;
	currentInput: checkboxesType;
	onInputChange: (newInput: checkboxesType) => void;
	quickSearch?: boolean;
	scrollable: boolean;
	onChangeClientState?: (clientStateInput: string[] | null) => void;
}

export default function Checkboxes({
	label,
	choices,
	criterionKey,
	currentInput,
	onChangeClientState = () => {},
	onInputChange,
	quickSearch,
	scrollable,
}: CheckboxesProps) {
	const { allChecked, onSelectAll } = useSelectAll(
		choices,
		currentInput,
		onInputChange,
	);
	const quickSearchId = quickSearch ? "_quick_search" : "";

	const handleToggle = (key: string) => {
		let newInput;
		const index = currentInput.indexOf(key);

		if (currentInput.includes(key)) {
			newInput = currentInput.delete(index);
		} else {
			newInput = currentInput.push(key);
		}

		const clientStateInput = !newInput.isEmpty() ? newInput.toJS() : null;
		onChangeClientState(clientStateInput);

		onInputChange(newInput);
	};

	const checkboxes = choices.map((choice) => {
		const { key, value } = choice;
		return (
			<SimpleCheckbox
				key={key}
				itemKey={key}
				value={value}
				checked={currentInput.includes(key)}
				onToggle={handleToggle}
				inputId={`${criterionKey}_${key}${quickSearchId}`}
			/>
		);
	});

	return (
		<fieldset className={`dropdown-menu-items`}>
			<legend>{label}</legend>

			<CriterionSelectAll
				quickSearchId={quickSearchId}
				criterionKey={criterionKey}
				isVisible={scrollable}
				allChecked={allChecked}
				onSelectAll={onSelectAll}
			/>

			{checkboxes}
		</fieldset>
	);
}
